import React from "react";
import { Modal } from "antd";
import { Localize } from "components/service";
import StaffScanLocationMap from "./staff-scan-location-map";
import {
    formatStaffCheckInHistoryDateTime,
    getStaffCheckInHistoryActor,
    getStaffCheckInHistoryComparison,
    getStaffCheckInHistoryMapSnapshot,
} from "../helpers/staff-check-in-history-presentation-helper";


const StaffCheckInHistoryDetailsModal = ({ log, onClose }) => {
    const snapshot = getStaffCheckInHistoryMapSnapshot(log);

    return (
        <Modal
            className="modal-standard staff-check-in-history-modal"
            centered
            visible={ Boolean(log) }
            title={ <Localize>STAFF_MANAGEMENT.History_DetailsTitle</Localize> }
            footer={ null }
            width={ 720 }
            destroyOnClose={ true }
            onCancel={ onClose }>
            { log &&
                <>
                    <div className="staff-check-in-history-modal__meta">
                        <span>
                            <Localize>STAFF_MANAGEMENT.History_ChangedBy</Localize>:{ " " }
                            <strong>{ getStaffCheckInHistoryActor(log) }</strong>
                        </span>
                        <span>
                            <Localize>STAFF_MANAGEMENT.History_DateTime</Localize>:{ " " }
                            <strong>{ formatStaffCheckInHistoryDateTime(log.created_at) }</strong>
                        </span>
                    </div>
                    <div className="staff-check-in-history-modal__comparison-scroll">
                        <table className="staff-check-in-history-modal__comparison">
                            <thead>
                                <tr>
                                    <th scope="col"><Localize>STAFF_MANAGEMENT.History_Field</Localize></th>
                                    <th scope="col"><Localize>STAFF_MANAGEMENT.History_Before</Localize></th>
                                    <th scope="col"><Localize>STAFF_MANAGEMENT.History_After</Localize></th>
                                </tr>
                            </thead>
                            <tbody>
                                { getStaffCheckInHistoryComparison(log).map((field) => (
                                    <tr
                                        key={ field.name }
                                        className={ field.changed ? "staff-check-in-history-modal__changed" : undefined }>
                                        <th scope="row"><Localize>{ field.labelKey }</Localize></th>
                                        <td>{ field.oldValue }</td>
                                        <td>{ field.newValue }</td>
                                    </tr>
                                )) }
                            </tbody>
                        </table>
                    </div>
                    <h3 className="staff-check-in-history-modal__map-title">
                        <Localize>STAFF_MANAGEMENT.History_NewPosition</Localize>
                    </h3>
                    { snapshot ?
                        <StaffScanLocationMap
                            key={ log.id }
                            scan={ snapshot.scan }
                            zone={ snapshot.zone } /> :
                        <p><Localize>STAFF_MANAGEMENT.History_NoPosition</Localize></p>
                    }
                </>
            }
        </Modal>
    );
};

export default StaffCheckInHistoryDetailsModal;
